const Config = {
  api: process.env.REACT_APP_API,
};
export default Config;
